// The stored `currentAdmin` changed shape in the S3 login cutover
// (admin-auth-consolidation Phase 2): admin-api's /v0/login returned
// `{ id, name, username }`, administrators' /v1/login returns `{ id, name, email }`.
//
// `username` always held an email, so sessions stored before the cutover stay
// usable — this alias lets them survive the deploy instead of being cleared.
// Without it every admin would be logged out at once and forced through the new
// <cl-login> with no fallback; with it, only new logins exercise the component.
//
// Remove once no pre-cutover session can still be live (admin tokens are 7d).
const adminEmail = (admin) => (admin && (admin.email || admin.username)) || ''

export default adminEmail
